import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/about/components/AboutInteractive.tsx");
